const comparators = require('./comparators')

class Comparator {
  constructor(comparator) {
    this.id = comparator.id || comparator._id
    this._id = this.id
    this.type = comparator.type
    this.description = comparator.description
  }

  compare(value, toCompare) {
    return comparators[this.type](value, toCompare)
  }
}

module.exports = Comparator
